import { useState } from 'react';
import { usePreservedCallback } from '@toss/react';
import { useSignInWithCode } from '@zep/apis';
export const useVerifyEmail = (email: string, initialCode = '') => {
  const [code, setCode] = useState(initialCode);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const {
    mutateAsync,
    isLoading
  } = useSignInWithCode();
  const verifyCode = usePreservedCallback(async () => {
    setErrorMessage('');
    return mutateAsync({
      email,
      code
    });
  });
  return {
    code,
    setCode,
    errorMessage,
    setErrorMessage,
    verifyCode,
    isLoading
  };
};